// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A question-and-answer widget, ideal for explaining complex issues to the reader.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Frequently-asked questions",
  id: "frequently-asked-questions",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/faq/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "FrequentlyAskedQuestionsConfigTool" */ "app/components/tools/FrequentlyAskedQuestionsConfigTool/FrequentlyAskedQuestionsConfigTool"),
    loading: DynamicImportLoader,
    modules: ["FrequentlyAskedQuestionsConfigTool"]
  })
};

export default CONFIG;
